import './App.css';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import { lazy, Suspense, useContext, useEffect } from 'react';
import Layout from './components/Layout/Layout';
import { DnDProvider } from './components/DnD/DnDContext';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import Loading from './components/Loading/Loading';
import SuspenseLoading from './components/Loading/SuspenseLoading';
import { LoadingProvider, useLoading } from './contexts/LoadingContext';
import Login from './pages/Auth/Login';
import RoleProtector from './components/roleprotector';
import { UserContext } from './Context/Usercontext';
import axios from 'axios';
import { Baseurl } from './Api/Baseurl';
import { jwtDecode } from 'jwt-decode';
import LoginProtector from './components/LoginProtector';
import CourseContent from './pages/Admin/Courses/CourseContent/CourseContent';
import CourseFlashcardItems from './pages/Admin/Courses/CourseContent/CourseFlashcardItems';
import Views from './pages/Admin/Views/Views';
import Modulemoderatores from './pages/Admin/Modulemoderatores/Modulemoderatores';
import AssignedModules from './pages/Admin/Modulemoderatores/AssignedModules';
import Modulemoderatordashboard from './pages/Modulemoderator/Dashboard/Modulemoderatordashboard';
import Mymodules from './pages/Modulemoderator/MyModules/Mymodules';

// lazy loading with CSS preloading to prevent FOUC

// admin pages
const Analysis = lazy(() => import("./pages/Admin/Analysis/Analysis"));
const Addmodrator = lazy(() => import("./pages/Admin/Modratores/Modratores"));
const Teachers = lazy(() => import("./pages/Admin/Teachers/Teachers"));
const Teachercodes = lazy(() => import("./pages/Admin/Teachers/Teachercodes"));
const Student = lazy(() => import("./pages/Admin/Student/Student"));
const StudentsRequests = lazy(() => import("./pages/Admin/StudentRequests/StudentRequests"));
const Subjects = lazy(() => import("./pages/Admin/Courses/Subjects"));
// const Coursedetails = lazy(() => import("./pages/Admin/Courses/Coursedetails"));
const Codes = lazy(() => import("./pages/Admin/Codes/Codes"));
const Assignedteachers = lazy(() => import("./pages/Admin/Courses/Assignedteachers/Assignedteachers"));
const QBank = lazy(() => import("./pages/Admin/Qbank/Qbank"));
// const QbankAdd = lazy(() => import("./pages/Admin/Qbank/QbankAdd/QbankAdd"));
// const Chapters = lazy(() => import("./pages/Admin/Qbank/QbankAdd/Chapters"));
// const Exams = lazy(() => import("./pages/Admin/Qbank/QbankAdd/Exams"));
const Questions = lazy(() => import("./pages/Admin/Qbank/Questions/Questions"));
const Vimeoaccounts = lazy(() => import("./pages/Admin/Vimeoaccounts/Vimeoaccounts"));
const Teacherofaccount = lazy(() => import("./pages/Admin/Vimeoaccounts/Teacherofaccount/Teacherofaccount"));

// Module components
const Modules = lazy(() => import("./pages/Admin/Modules/Modules"));
const ModuleContent = lazy(() => import("./pages/Admin/Modules/ModuleContent"));
const ModuleQuestions = lazy(() => import("./pages/Admin/Modules/ModuleQuestions"));
const ModuleQuestionForm = lazy(() => import("./pages/Admin/Modules/ModuleQuestionForm"));
const AddModule = lazy(() => import("./pages/Admin/Modules/AddModule"));
const EditModule = lazy(() => import("./pages/Admin/Modules/EditModule"));
const FlashcardItems = lazy(() => import("./pages/Admin/Modules/FlashcardItems"));
// Verifications component
const Verifications = lazy(() => import("./pages/Admin/Verifications/Verifications"));
// admin pages

// teacher pages 
const AddQuestionform = lazy(() => import("./pages/Admin/Qbank/Questions/Addform/AddQuestionform"));
const Unusedcodes = lazy(() => import("./pages/Teatcher/Codes/Unusedcodes"));
// New teacher components
const TeacherDashboard = lazy(() => import("./pages/Teacher/Dashboard/TeacherDashboard"));

const TeacherAnalytics = lazy(() => import("./pages/Teacher/Analytics/TeacherAnalytics"));
const TeacherCourses = lazy(() => import("./pages/Teacher/Courses/TeacherCourses"));
const CourseStudentsTable = lazy(() => import("./pages/Teacher/Students/CourseStudentsTable"));

// teacher pages 

const Notfound = lazy(() => import("./components/Notfound/Notfound"));
// lazy 

const CommentsManagement = lazy(() => import("./pages/Admin/Comments/CommentsManagement"));

// Main Site Management pages
const CareersManagement = lazy(() => import("./pages/Admin/MainSite/CareersManagement"));
const CareerApplicationsManagement = lazy(() => import("./pages/Admin/MainSite/CareerApplicationsManagement"));
const ContactHomeManagement = lazy(() => import("./pages/Admin/MainSite/ContactHomeManagement"));
const TeacherApplicationsManagement = lazy(() => import("./pages/Admin/MainSite/TeacherApplicationsManagement"));

function AppContent() {
  const { setUserRole, setuserId } = useContext(UserContext);
  const { isLoading, setIsLoading } = useLoading();
  const token = localStorage.getItem('medtoken');


  useEffect(() => {
    // console.clear();
    const CallRole = async () => {
      if (!token) {
        setIsLoading(false)
        return
      };

      try {
        const { data } = await axios.post(`${Baseurl}/auth/getRoleByEmail`, {
          email: jwtDecode(token).email
        });

        setuserId(jwtDecode(token).id)
        setUserRole(data?.payload?.role)

      } catch (error) {
        setUserRole(null)
      } finally {
        setIsLoading(false)
      }
    }

    CallRole();

  }, [token]);



  let routes = createHashRouter([
    {

      // Admin 
      path: "", element: <Layout role={"admin"} />, children: [
        {
          index: true, element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Analysis />
                </RoleProtector>
              </Suspense >

            </LoginProtector>
        },
        {
          path: "vimeoaccounts", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Vimeoaccounts />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "/vimeoaccounts/teachersofaccount/:accountId", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Teacherofaccount />
                </RoleProtector>
              </Suspense>
            </LoginProtector>

        },
        {
          path: "moderatores", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Addmodrator />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modulemoderatores", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Modulemoderatores />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modulemoderatores/AssignedModules/:moderatorId", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <AssignedModules />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "teachers", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Teachers />
                </RoleProtector>
              </Suspense>

            </LoginProtector>
        },
        {
          path: "/teachers/codes/:teacherid", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Teachercodes />
                </RoleProtector>
              </Suspense>

            </LoginProtector>
        },
        {
          path: "students", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Student />
                </RoleProtector>
              </Suspense>
            </LoginProtector>

        },
        {
          path: "students/requests", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <StudentsRequests />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "courses", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Subjects />
                </RoleProtector>
              </Suspense>
            </LoginProtector>

        },
        {
          path: "/courses/coursesdetails/:courseId/:teacherid", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <CourseContent />
                </RoleProtector>
              </Suspense>
            </LoginProtector>

        },
        {
          path: "/courses/assignedteachers/:subjectId", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Assignedteachers />
                </RoleProtector>
              </Suspense>
            </LoginProtector>

        },
        {
          path: "/courses/:courseId/flashcard-sets/:flashcardSetId/items", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <CourseFlashcardItems />
                </RoleProtector>
              </Suspense>
            </LoginProtector>

        },
        {
          path: "Qbank", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <QBank />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Modules />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/add", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <AddModule />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:id/edit", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <EditModule />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/content", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <ModuleContent />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/qbanks/:qBankId/questions", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <ModuleQuestions />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/qbanks/:qBankId/questionform", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <ModuleQuestionForm />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/flashcards/:flashcardSetId/items", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <FlashcardItems />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "Questions/:qBankId", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Questions />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "Questions/:qBankId/questionform", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <AddQuestionform />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "codes", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Codes />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "verifications", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Verifications />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "Comments", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <CommentsManagement />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "Views", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <Views />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "admin/careers", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <CareersManagement />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "admin/career-applications", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <CareerApplicationsManagement />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "admin/contacts", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <ContactHomeManagement />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "admin/teacher-applications", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="admin">
                  <TeacherApplicationsManagement />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        // Admin 
        {
          path: "*", element: <Suspense fallback={<SuspenseLoading />}>
            <Notfound />
          </Suspense>
        }]
    },

    // moderator 
    {
      path: "moderator",
      element: <Layout role={"moderator"} />,
      children: [
        {
          index: true,
          element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <Teachers />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "teachers/codes/:teacherid", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <Teachercodes />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "students", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <Student />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "courses", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <Subjects />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "courses/coursesdetails/:courseId/:teacherid", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <CourseContent />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "courses/assignedteachers/:subjectId", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <Assignedteachers />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "courses/:courseId/flashcard-sets/:flashcardSetId/items", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <CourseFlashcardItems />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "Qbank", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <QBank />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "Questions/:qBankId", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <Questions />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "Questions/:qBankId/questionform", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <AddQuestionform />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "codes", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <Codes />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <Modules />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/add", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <AddModule />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:id/edit", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <EditModule />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/content", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <ModuleContent />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/qbanks/:qBankId/questions", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <ModuleQuestions />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/qbanks/:qBankId/questionform", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <ModuleQuestionForm />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/flashcards/:flashcardSetId/items", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="moderator">
                  <FlashcardItems />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "*", element:
            <Suspense fallback={<SuspenseLoading />}>
              <Notfound />
            </Suspense>
        }
      ]
    },

    // modulemoderator
    {
      path: "modulemoderator",
      element: <Layout role={"modulemoderator"} />,
      children: [
        {
          index: true,
          element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="modulemoderator">
                  <Modulemoderatordashboard />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },

        {
          path: "MyModules", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="modulemoderator">
                  <Mymodules />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/content", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="modulemoderator">
                  <ModuleContent />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/qbanks/:qBankId/questions", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="modulemoderator">
                  <ModuleQuestions />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/qbanks/:qBankId/questionform", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="modulemoderator">
                  <ModuleQuestionForm />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "modules/:moduleId/flashcards/:flashcardSetId/items", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="modulemoderator">
                  <FlashcardItems />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "*", element:
            <Suspense fallback={<SuspenseLoading />}>
              <Notfound />
            </Suspense>
        }
      ]
    },


    // teacher 
    {
      path: "teacher", element: <Layout role={"teacher"} />, children: [
        {
          index: true, element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="teacher">
                  <TeacherDashboard />
                </RoleProtector>
              </Suspense >
            </LoginProtector>
        },
        {
          path: "courses", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="teacher">
                  <TeacherCourses />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "courses/coursesdetails/:courseId/:teacherid", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="teacher">
                  <CourseContent />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "courses/:courseId/flashcard-sets/:flashcardSetId/items", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="teacher">
                  <CourseFlashcardItems />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "Qbank", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="teacher">
                  <QBank />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "Questions/:qBankId", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="teacher">
                  <Questions />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "Questions/:qBankId/questionform", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="teacher">
                  <AddQuestionform />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "courses/:courseId/students", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="teacher">
                  <CourseStudentsTable />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "analytics", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="teacher">
                  <TeacherAnalytics />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },
        {
          path: "codes", element:
            <LoginProtector>
              <Suspense fallback={<SuspenseLoading />}>
                <RoleProtector requiredRole="teacher">
                  <Unusedcodes />
                </RoleProtector>
              </Suspense>
            </LoginProtector>
        },

        // teacher 
        {
          path: "*", element: <Suspense fallback={<SuspenseLoading />}>
            <Notfound />
          </Suspense>
        }]
    },



    {
      path: "Login", element: <Suspense><Login /></Suspense>
    },

  ]);

  return (
    <>
      <Loading />
      {!isLoading && (
        <DndProvider backend={HTML5Backend}>
          <DnDProvider onDataChange={() => { }}>
            <RouterProvider router={routes}></RouterProvider>
          </DnDProvider>
        </DndProvider>
      )}
    </>
  )
}

function App() {
  return (
    <LoadingProvider>
      <AppContent />
    </LoadingProvider>
  )
}

export default App;
